import { render, staticRenderFns } from "./SubmitForm14.vue?vue&type=template&id=245cc2de&scoped=true"
import script from "./SubmitForm14.vue?vue&type=script&lang=ts"
export * from "./SubmitForm14.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245cc2de",
  null
  
)

export default component.exports